// Maps a backend return-receipt `code` (ReturnsController#receive / #create) to an
// operator-facing i18n key. Mirrors the GenerateShipment errorMessages contract.
// Only codes with a dedicated, actionable message live here; anything else falls
// back to the raw server message (see resolveReturnReceiveErrorMessage).
//
// Source of truth for the codes: platform app/errors/invoice_error_codes.rb.
export const RETURN_ERROR_CODE_MESSAGES = {
  RETURN_NO_APPROVED_SALE_INVOICE: 'returns.errors.error_codes.no_approved_sale_invoice',
  RETURN_NO_PRODUCTS: 'returns.errors.error_codes.no_products',
  RETURN_ALL_MISSING_NOT_CONFIRMED: 'returns.errors.error_codes.all_missing_not_confirmed',
  INVOICE_CERTIFICATE_INVALID: 'returns.errors.error_codes.certificate_invalid',
  INVOICE_NO_ICMS_RATE: 'returns.errors.error_codes.no_icms_rate',
  INVOICE_ESTORNO_MISSING_SUBTOTAL: 'returns.errors.error_codes.estorno_missing_subtotal',
  INVOICE_PRODUCT_INVALID_PRICE: 'returns.errors.error_codes.product_invalid_price',
  FISCAL_REJECTION: 'returns.errors.error_codes.fiscal_rejection',
  INVOICE_GENERATION_FAILED: 'returns.errors.error_codes.invoice_generation_failed',
  TRANSIENT_RETRY: 'returns.errors.error_codes.transient_retry',
  UNIDENTIFIED_RETURNS_NOT_ENABLED: 'returns.errors.error_codes.unidentified_not_enabled',
  UNIDENTIFIED_RETURNS_REQUIRE_WEBMANIA: 'returns.errors.error_codes.unidentified_require_webmania',
  UNIDENTIFIED_RETURNS_REQUIRE_REPLENISHMENT_INVOICES: 'returns.errors.error_codes.unidentified_require_replenishment_invoices',
}

// Raw server message fallback for a failed request: prefer the legacy `error`
// field, then the newer `message` field, then the JS error's own message.
export const getReturnBackendErrorMessage = err => err?.response?.data?.error || err?.response?.data?.message || err?.message || ''

// Resolve the operator-facing message for a failed return receive/create request.
// A known `code` maps to a translated, actionable message; otherwise we fall back
// to whatever message the server provided. For a SEFAZ rejection (FISCAL_REJECTION)
// the backend also sends `reason` — the actual SEFAZ text — which we append so the
// operator sees exactly why the tax authority rejected it.
export const resolveReturnReceiveErrorMessage = (err, translate) => {
  const data = err?.response?.data
  const code = data?.code
  if (code && RETURN_ERROR_CODE_MESSAGES[code]) {
    const message = translate(RETURN_ERROR_CODE_MESSAGES[code])
    if (code === 'FISCAL_REJECTION' && data?.reason) {
      return `${message} ${data.reason}`
    }
    return message
  }
  return getReturnBackendErrorMessage(err)
}

// Resolve the WMS copy for a failed return lookup (GET orders/wms/find-order-return).
// Unlike the receive map above, which keys on `code`, the lookup endpoint keys on
// `error_code`. Returns null for anything without dedicated copy.
export const resolveFindOrderReturnErrorMessage = (err, translate) => {
  const data = err?.response?.data
  if (data?.error_code === 'CUBBITO_RETURN_WRONG_WAREHOUSE') {
    return translate('returns.errors.cubbito_wrong_warehouse', { warehouse_code: data.error_context?.warehouse_unique_code })
  }
  return null
}
